export default __webpack_public_path__ + "static/icon-6-5-c65f86e7672621aa85d083e348aa48fe.png";